import i18n from "@src/common/lib/i18n";
import { Dic } from "@src/common/utils";
export const deviceTableOption = function (cameraFeatureShow, menuShow) {
  if (cameraFeatureShow) {
    // console.log('cameraFeatureShow', cameraFeatureShow)
    return {
      stripe: true,
      page: true,
      maxHeight: "100%",
      align: "center",
      header: false,
      selection: true,
      emptyText: i18n.t("cameraList.title.noData"),
      delBtn: false,
      editBtn: false,
      menu: false,
      column: [
        {
          prop: "check",
          hide:true,
          search:true,
          searchSlot: true,
        },
        {
          label: i18n.t("cameraList.label.deviceName"),
          prop: "deviceName",
          align: "center",
          search: true,
          overHidden: true,
          columnWidth:200
        },
        {
          label: "第三方设备编号",
          prop: "thirdDeviceId",
          overHidden: true,
          search:false,
          columnWidth:200
        },
        {
          label: i18n.t("cameraList.label.deviceId"),
          prop: "deviceId",
          overHidden: true,
          search:true,
        },
        {
          label: i18n.t("cameraList.label.ip"),
          prop: "ip",
          overHidden: true
        },
        {
          label: i18n.t("cameraList.label.port"),
          prop: "port",
          hide: true,
          overHidden: true
        },
        // {
        //   label: "所属NVR名称",
        //   prop: "parentDeviceName",
        //   overHidden: true
        // },
        // {
        //   label: "所属NVR IP",
        //   prop: "parentIp",
        //   overHidden: true
        // },
        {
          label: i18n.t("cameraList.label.systemName"),
          prop: "systemName",
          align: "center",
          hide: true,
          overHidden: true
        },
        // {
        //   label: i18n.t('cameraList.label.deviceType'),
        //   prop: 'cameraTypeName',
        //   overHidden: true,
        //   align: 'center'
        // },
        {
          label: i18n.t("cameraList.label.factory"),
          prop: "factoryName",
          overHidden: true
        },
        {
          label: i18n.t("cameraList.label.equipmentGroup"),
          prop: "deviceWorkGroupName",
          align: "center",
          overHidden: true
        },
        {
          label: i18n.t("cameraList.label.statusName"),
          prop: "statusName",
          overHidden: true
        },
        {
          label: i18n.t("cameraList.label.statusName"),
          prop: "status",
          overHidden: true,
          hide: true,
          type: "select",
          dicData: [
            {
              label: "离线",
              value: 0
            },
            {
              label: "在线",
              value: 1
            }
          ],
          search: true
        },
        // {
        //   label: i18n.t("cameraList.label.attribute"),
        //   prop: "cameraFeatureName",
        //   // overHidden: true,
        //   slot: true,
        //   dicData: Dic.find("SENU014")
        // },
        // {
        //   label: i18n.t("cameraList.label.attribute"),
        //   prop: "cameraFeature",
        //   // overHidden: true,
        //   search: true,
        //   hide:true,
        //   type: "select",
        //   dicData: Dic.find("SENU014")
        // },
        {
          label: i18n.t("cameraList.label.synTime"),
          prop: "createrTime",
          // overHidden: true,
          slot: true
        },
        {
          label: i18n.t("cameraList.label.operate"),
          prop: "operate",
          hide: true,
          slot: true
        }
      ]
    };
  } else {
    return {
      stripe: true,
      page: true,
      maxHeight: "100%",
      align: "center",
      header: false,
      selection: true,
      emptyText: i18n.t("cameraList.title.noData"),
      delBtn: false,
      editBtn: false,
      menu: false,
      column: [
        {
          prop: "check",
          hide:true,
          search:true,
          searchSlot: true,
        },
        {
          label: i18n.t("cameraList.label.deviceName"),
          prop: "deviceName",
          overHidden: true,
          columnWidth:200,
          search:true
        },
        {
          label: i18n.t("cameraList.label.doorId"),
          prop: "thirdDeviceId",
          overHidden: true
        },
        {
          label: i18n.t("cameraList.label.deviceId"),
          prop: "deviceId",
          overHidden: true
        },
        {
          label: i18n.t("cameraList.label.systemName"),
          prop: "systemName",
          // align: 'left',
          hide: true,
          overHidden: true
        },
        // {
        //   label: i18n.t('cameraList.label.deviceType'),
        //   prop: 'deviceTypeName',
        //   overHidden: true,
        // },
        {
          label: i18n.t("cameraList.label.factory"),
          prop: "factoryName",
          overHidden: true,
          slot: true
        },
        {
          label: i18n.t("cameraList.label.areaName"),
          prop: "areaName",
          // align: 'left',
          overHidden: true,
        },
        {
          label: i18n.t("cameraList.label.statusName"),
          prop: "statusName",
          overHidden: true,
        },
        {
          label: i18n.t("cameraList.label.statusName"),
          prop: "status",
          hide:true,
          type: "select",
          dicData: [
            {
              label: "离线",
              value: 0
            },
            {
              label: "在线",
              value: 1
            }
          ],
          search: true
        },
        {
          label: i18n.t("cameraList.label.operate"),
          prop: "operate",
          hide: false,
          slot: true
        }
      ]
    };
  }
};
